import { render, staticRenderFns } from "./CriterioSelect.vue?vue&type=template&id=6533342d"
import script from "./CriterioSelect.vue?vue&type=script&lang=js"
export * from "./CriterioSelect.vue?vue&type=script&lang=js"
import style0 from "./CriterioSelect.vue?vue&type=style&index=0&id=6533342d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports